<template>
    <div>
        <div class="nav primary-bg pl20 pr20 pt10 pb10">
            <div class="box-horizontal">
                <div class="" @click="met.back()">
                    <img src="@/assets/back.png" alt="" style="height:30px">
                </div>
                <div class="flex-1 f13 text-center white">
                    Pengaduan Detail
                </div>
                <div class="">
                    <img src="@/assets/back.png" alt="" style="height:30px;opacity:0">
                </div>
            </div>
        </div>
        <div class="wrapper">
            <div class="body">
                <div class="mb10 mt10">
                    <div class="data bg-round-white p10 mb10">
                        <div class="box-horizontal">
                            <div class="flex-1 f13">
                                <small class="block gray">Tanggal : </small>
                                <span class="block f13 primary-color">{{myGlobal.tglIndo(get.data.params.tanggal)}} || {{get.data.params.jam}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="data bg-round-white p10 mb10">
                        <div class="box-horizontal">
                            <div class="flex-1 f13">
                                <small class="block gray">Pengaduan : </small>
                                <span class="block f13 primary-color">{{get.data.params.text}}</span>
                            </div>
                        </div>
                        <div class="box-horizontal">
                            <div class="flex-1 f13">
                                <small class="block gray">Teknisi : </small>
                                <span class="block f13 primary-color" v-show="get.data.job_teknisi != null" v-html="get.data.job_teknisi"></span>
                                <span class="block f13 primary-color" v-show="get.data.job_teknisi == null">{{get.data.params.teknisi}}</span>
                            </div>
                        </div>
                        <div class="box-horizontal" v-show="get.data.job_teknisi != null">
                            <div class="flex-1 f13">
                                <small class="block gray mb10">Status : </small>
                                <div class="box-horizontal m0">
                                    <div class="mr10">
                                        <div class="dot"></div>
                                    </div>
                                    <div class="flex-1">
                                        <span class="orange block f15">Pending</span>
                                        <span class="gray f12">{{myGlobal.tglIndo(get.data.job_tanggal)}} - {{get.data.job_jam}}</span>
                                    </div>
                                </div>
                                <div class="box-horizontal m0" v-show="get.data.job_tgl_proses != null">
                                    <div class="garis"></div>
                                </div>
                                <div class="box-horizontal m0" v-show="get.data.job_tgl_proses != null">
                                    <div class="mr10">
                                        <div class="dot"></div>
                                    </div>
                                    <div class="flex-1">
                                        <span class="blue block f15">Proses</span>
                                        <span class="gray f12">{{myGlobal.tglIndo(get.data.job_tgl_proses)}} - {{get.data.job_jam_proses}}</span>
                                    </div>
                                </div>
                                <div class="box-horizontal m0" v-show="get.data.job_tgl_selesai != null">
                                    <div class="garis"></div>
                                </div>
                                <div class="box-horizontal m0" v-show="get.data.job_tgl_selesai != null">
                                    <div class="mr10">
                                        <div class="dot"></div>
                                    </div>
                                    <div class="flex-1">
                                        <span class="green block f15">Selesai</span>
                                        <span class="gray f12">{{myGlobal.tglIndo(get.data.job_tgl_selesai)}} - {{get.data.job_jam_selesai}}</span>
                                    </div>
                                </div>
                                <!--
                                <span v-if="get.data.params.status == 'pending'" class="orange">Pending</span>
                                <span v-else-if="get.data.params.status == 'proses'" class="blue">Proses</span>
                                <span v-else class="green">Selesai</span>
                                -->
                            </div>
                        </div>
                        <div class="box-horizontal" v-show="get.data.kerusakan">
                            <div class="flex-1 f13">
                                <small class="block gray">Kerusakan : </small>
                                <span class="orange">{{get.data.kerusakan}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import myGlobal from '@/MyGlobal'
import { reactive } from '@vue/composition-api'
import store from '@/store/index'
import inter from '@/Interface'
import router from '@/router'
import Loading from '@/global/Loading' 

export default {
    setup() {
        const get = {
            data: reactive({
                this: '',
                params: '',
                job_teknisi: null,
                job_tanggal: '',
                job_jam: '',
                job_tgl_proses: '',
                job_jam_proses: '',
                job_tgl_selesai: '',
                job_jam_selesai: '',
                kerusakan: ''
            }),
            detail() {
                var datax = {
                    token: 'TangTung ' + sessionStorage.getItem('tokenu'),
                    id: this.data.params.id
                };
            
                var apiUrl = inter.PengaduanDetail();

                myGlobal.call(datax,apiUrl).then(x => {

                    if (x.status == true) {
                        var d = x.data;
                        this.data.job_teknisi = d.teknisi;
                        this.data.job_tanggal = d.data.tanggal;
                        this.data.job_jam = d.data.jam;
                        this.data.job_tgl_proses = d.data.tgl_proses;
                        this.data.job_jam_proses = d.data.jam_proses;
                        this.data.job_tgl_selesai = d.data.tgl_selesai;
                        this.data.job_jam_selesai = d.data.jam_selesai;
                        this.data.kerusakan = d.data.kerusakan;
                    } else {
                        
                    }
                })
            }
        }
        const met = {
            back() {
                window.history.back();
            },
            logout() {
                myGlobal.android("logout" , null);
            },
            wa() {
                myGlobal.android("waCS" , get.data.cs);
            },
            pengaduan() {
                router.push({ 
                    name: 'pengaduan'
                });
            }
        }

        const redirectx = {
            checkApp() {
                myGlobal.checkApp();
            },
            now() {
                location.href="#/";
            }
        }

        return {
            met,
            get,
            redirectx,
            myGlobal
        }

    },
    mounted () {        
        this.redirectx.checkApp();
        
        //console.log(sessionStorage.getItem('AkunPageData'));
        this.get.data.params = this.$route.params.data;

        var d = this.get.data.params;

        console.log(JSON.stringify(d));

        this.get.detail();
        
    }
}
</script>

<style scoped>
.dot {
    width: 10px;
    height: 10px;
    background-color: rgb(117, 117, 117);
    border-radius: 20px;
}
.garis {
    margin-left: 3px;
    margin-right: 3.5px;
    width: 3px;
    height: 30px;
    background-color: rgb(165, 165, 165);
}
</style>


// WEBPACK FOOTER //
// src/components/User/Akun/Pengaduan/detail.vue